/********************************************************************
 * ADOBE CONFIDENTIAL
 * __________________
 *
 *  Copyright 2026 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 *******************************************************************/

import { CART_FRAGMENT } from '@/cart/api/graphql/CartFragment';

/** `Magento\\SalesRuleFreeGift` — `selectFreeGiftForCart` mutation. */
export const SELECT_FREE_GIFT_FOR_CART_MUTATION = /* GraphQL */ `
  mutation SELECT_FREE_GIFT_FOR_CART(
    $input: SelectFreeGiftForCartInput!
    $pageSize: Int! = 100
    $currentPage: Int! = 1
    $itemsSortInput: QuoteItemsSortInput! = { field: CREATED_AT, order: DESC }
  ) {
    selectFreeGiftForCart(input: $input) {
      cart {
        ...CART_FRAGMENT
      }
    }
  }

  ${CART_FRAGMENT}
`;
